import validateFile, {
  formatFileSize,
  MAX_FILE_SIZE_BYTES,
} from './fileValidation';
import { UPLOAD_ERRORS } from './copy';

const file = ({ name = 'users.csv', size = 1024, type = 'text/csv' }) => ({
  name,
  size,
  type,
});

describe('management/Users BulkCreateUserWizard fileValidation', () => {
  it('accepts a plain CSV', () => {
    expect(validateFile(file({}))).toBeNull();
  });

  // Excel on Windows announces a .csv as an Excel document, and some browsers
  // send nothing at all. Mirrors BulkImportable::VALID_CSV_CONTENT_TYPES.
  it.each(['text/csv', 'application/csv', 'application/vnd.ms-excel'])(
    'accepts the %s a browser may report',
    (type) => {
      expect(validateFile(file({ type }))).toBeNull();
    },
  );

  it('falls back to the extension when the type is too generic', () => {
    expect(
      validateFile(
        file({ type: 'application/octet-stream', name: 'users.csv' }),
      ),
    ).toBeNull();
  });

  it('rejects a generic type without the extension', () => {
    expect(validateFile(file({ type: '', name: 'users.xlsx' }))).toEqual(
      UPLOAD_ERRORS.wrongType,
    );
  });

  it('rejects a definitive non-CSV even when named .csv', () => {
    expect(
      validateFile(file({ type: 'application/pdf', name: 'users.csv' })),
    ).toEqual(UPLOAD_ERRORS.wrongType);
  });

  it('rejects a file over the size limit', () => {
    expect(validateFile(file({ size: MAX_FILE_SIZE_BYTES + 1 }))).toEqual(
      UPLOAD_ERRORS.tooLarge,
    );
  });

  it('accepts one exactly at the limit', () => {
    expect(validateFile(file({ size: MAX_FILE_SIZE_BYTES }))).toBeNull();
  });

  // The type is the more useful answer of the two, so it wins.
  it('reports the type first for a large non-CSV', () => {
    expect(
      validateFile(
        file({ type: 'application/pdf', size: MAX_FILE_SIZE_BYTES + 1 }),
      ),
    ).toEqual(UPLOAD_ERRORS.wrongType);
  });

  it('passes when nothing has been chosen', () => {
    expect(validateFile(null)).toBeNull();
  });

  describe('formatFileSize', () => {
    it('labels the chosen file as the mockup does', () => {
      expect(formatFileSize(512)).toEqual('512 B');
      expect(formatFileSize(1536)).toEqual('1.5 KB');
      expect(formatFileSize(1.2 * 1024 * 1024)).toEqual('1.2 MB');
    });
  });
});
